import styled from 'styled-components';

export const Label = styled.span`
  padding: 2px 12px;
  text-align: center;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
  background-color: ${props => getLabelColor(props.count, props.ranges)};
  display: inline-block;
  white-space: nowrap;
  margin-left: 8px;
`;

export function getLabelColor(count, ranges) {
  for (const [color, range] of Object.entries(ranges)) {
    const [min, max] = range;
    if (count >= min && count <= max) {
      return color;
    }
  }
  return 'gray'; // fallback color
}

